import {Spinner, styled} from '@volkswagen-onehub/components-core';
import React from 'react';

const SpinnerWrapper = styled.div`
  width: 100%;
  margin: ${props => props.theme.size.dynamic0100} auto;
  display: grid;
  justify-content: center;
  align-content: center;
  pointer-events: none;
`;

const Loader = () => {
  return (
    <SpinnerWrapper>
      <Spinner variant="x-large" />
    </SpinnerWrapper>
  );
};

export default Loader;
